/* ============================================================
 * Melinda Maria — Cart Upsell
 * ------------------------------------------------------------
 * Extracted from snippets/mm_cart-upsell.liquid. Loaded from
 * layout/theme.liquid <head> so it's present in the initial
 * HTML — required because Horizon's cart morph refuses to
 * execute <script> tags that are inserted after page load
 * (browser security). Inline scripts in the snippet broke on
 * pages that loaded with an empty cart and only later morphed
 * to a non-empty state.
 *
 * Loaded conditionally from layout/theme.liquid when
 * settings.cart_upsell_enabled is true — zero footprint
 * otherwise.
 * ============================================================ */

(() => {
  if (window.__mmUpsellBound) return;
  window.__mmUpsellBound = true;

  function findCartItemsComponent(el) {
    return (
      el.closest('cart-items-component') ||
      document.querySelector('cart-items-component')
    );
  }

  const UPSELL_ADD_SOURCE = 'mm-upsell-add';

  /**
   * Collect every cart-items-component section ID on the page so /cart/add.js
   * can return fresh section HTML for all of them in one shot.
   */
  function collectCartSectionIds() {
    const sections = new Set();
    document.querySelectorAll('cart-items-component').forEach((c) => {
      if (c instanceof HTMLElement && c.dataset.sectionId) {
        sections.add(c.dataset.sectionId);
      }
    });
    return Array.from(sections);
  }

  async function addVariant(variantId) {
    const body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: collectCartSectionIds().join(','),
      sections_url: window.location.pathname,
    };
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body),
    });
    if (!res.ok) throw new Error('Failed to add upsell item');
    return res.json();
  }

  async function getCart() {
    const res = await fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' },
    });
    return res.json();
  }

  /**
   * Dispatch Horizon-native cart:update event so every cart surface
   * (cart-items-component, cart icon, GWP auto-remove listener, etc.)
   * refreshes in sync from one payload.
   */
  function dispatchCartUpdate(cart, sections) {
    const itemCount =
      typeof cart.item_count === 'number'
        ? cart.item_count
        : Array.isArray(cart.items)
          ? cart.items.length
          : 0;
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: UPSELL_ADD_SOURCE,
          data: {
            source: UPSELL_ADD_SOURCE,
            itemCount,
            sections: sections || {},
          },
        },
      })
    );
  }

  async function refreshCartItemsComponent(cartItemsComponent) {
    if (!cartItemsComponent) return;

    const sectionId = cartItemsComponent.dataset.sectionId;
    if (!sectionId) return;

    const url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('sections', sectionId);

    const res = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!res.ok) return;

    const json = await res.json();
    const html = json && json[sectionId];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newComponent = doc.querySelector('cart-items-component');
    const currentComponent = document.querySelector('cart-items-component');

    if (newComponent && currentComponent) {
      currentComponent.replaceWith(newComponent);
    }
  }

  /**
   * Tiles stay visible regardless of whether the product is already in
   * cart — the mystery products have multiple variants (gold / silver)
   * selectable from the same tile, and hiding on add would prevent the
   * customer from adding the other variant.
   *
   * Function kept (no-op) so the existing call site stays valid and so
   * future variant-level hiding can be slotted in here cleanly.
   */
  function updateUpsellUI(/* cart */) {
    /* intentionally empty — tiles always show */
  }

  document.addEventListener(
    'click',
    async (e) => {
      const btn = e.target.closest('[data-mm-upsell-add]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;

      try {
        // 1) Add the item. Response includes sections HTML for morphing.
        const addResponse = await addVariant(variantId);

        // 2) Fetch the full cart so downstream listeners (GWP auto-remove,
        //    cart icon, etc.) get an authoritative cart body to read.
        //    /cart/add.js response is line-item-shaped, not cart-shaped.
        let cart;
        try { cart = await getCart(); } catch (_) { cart = null; }

        // 3) Dispatch cart:update so every cart surface updates in sync —
        //    including Horizon's cart-items-component which will morph
        //    itself from data.sections[sectionId].
        if (cart) {
          dispatchCartUpdate(cart, addResponse && addResponse.sections);
        }

        updateUpsellUI(cart);
      } catch (err) {
        console.error('[mm_upsell] add failed:', err);
      } finally {
        btn.disabled = false;
      }
    },
    true
  );
})();
